
import Listener from './Listener'

var ListenerMap = function (src) {
  this.src = src
  this.listeners = {}
}

ListenerMap.prototype.add = function (
  type,
  listener,
  callOnce,
  opt_useCapture,
  opt_listenerScope
) {
  var listenerArray = this.listeners[type]
  if (!listenerArray) {
    listenerArray = this.listeners[type] = []
  }

  var listenerObj = new Listener(
    listener,
    null,
    this.src,
    type,
    !!opt_useCapture,
    opt_listenerScope
  )

  listenerArray.push(listenerObj)
}

/**
 * Remove a listener from the map.
 */
ListenerMap.prototype.remove = function (type, listener) {

  if (!this.listeners || !this.listeners[type]){
    console.warn('Removing an event on a destroyed instance. Doing nothing...')
    return
  }

  var listenerArray = this.listeners[type] || []

  var matchedIndex = listenerArray.findIndex((l) => {
    return (l.listener = listener)
  })
  if (matchedIndex == -1) throw new Error('Listener not found.')

  var listener = listenerArray[matchedIndex]
  listener.destroy()

  listenerArray.splice(matchedIndex, 1)
}

ListenerMap.prototype.destroy = function () {
  delete this.src
  for (var key in this.listeners) {
    var listenersArray = this.listeners[key]
    for (var listener of listenersArray) {
      listener.destroy()
    }
    delete this.listeners[key]
  }
  delete this.listeners
}

export default ListenerMap
